import { store } from '../../../../../../store/store';
import actions from '../actions';
export const updateLocationForSharedRoom = ({ roomId }) => (locationId) => {
    const action = actions.updateLocationForSharedRoom({
        roomId,
        locationId,
    });
    store.dispatch(action);
};
